const IMAGE_BASE =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
    ? 'http://127.0.0.1:8080'
    : '';

const resolveImageUrl = (raw) => {
  if (!raw) return null;
  const value = typeof raw === 'string' ? raw : raw?.image;
  if (!value) return null;
  return value.startsWith('http') ? value : `${IMAGE_BASE}${value}`;
};

export const getNegotiationItemTitle = (negotiation, item) => {
  if (negotiation?.item_title) return negotiation.item_title;
  if (item?.title) return item.title;
  if (item?.item_name) return item.item_name;
  return 'Item';
};

export const getNegotiationItemCode = (negotiation, item) => {
  return negotiation?.item_code || item?.item_code || '';
};

export const getNegotiationDisplayLabel = (negotiation, item) => {
  if (negotiation?.display_label) return negotiation.display_label;
  return `Negotiation on ${getNegotiationItemTitle(negotiation, item)}`;
};

export const getNegotiationItemImageUrl = (negotiation, item) => {
  if (negotiation?.item_image_url) return negotiation.item_image_url;
  return (
    resolveImageUrl(item?.primary_image) ||
    resolveImageUrl(item?.image_url) ||
    resolveImageUrl(item?.images?.[0]) ||
    resolveImageUrl(item?.images?.[0]?.image) ||
    null
  );
};
